var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgServer = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M13 2.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3.162 4.965a7.302 7.302 0 0 1 1.587 3.035H6.25a7.301 7.301 0 0 1 1.587-3.035C8.986 6.173 10.49 5.5 12 5.5c1.51 0 3.014.673 4.162 1.965ZM4.2 10.5c.332-1.64 1.07-3.156 2.143-4.364C7.843 4.448 9.878 3.5 12 3.5s4.157.948 5.657 2.636C18.73 7.344 19.467 8.86 19.8 10.5H21a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h1.2Zm5.361 3a3 3 0 0 0-2.484 1.319L4.172 19.11a1 1 0 1 0 1.656 1.121l2.905-4.292a1 1 0 0 1 .828-.44h5.514a4 4 0 0 1-2.646 1h-.375a2 2 0 0 0-1.696.94l-2.206 3.53a1 1 0 0 0 1.696 1.06l2.206-3.53h.375a6 6 0 0 0 4.243-1.757l1.535-1.536A1 1 0 0 0 17.5 13.5H9.561Z",
  clipRule: "evenodd"
})));
SvgServer.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgServer);
export default ForwardRef;